import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import translate from 'angular-translate';
import translateStaticLoader from "angular-translate-loader-static-files";
import Common from './common/common';
import Routes from './routes/routes';
import AppComponent from './app.component';
import ngResource from 'angular-resource';
import angularMessages from 'angular-messages';
import offClick from './chaps/offClick-loader';
import sharedService from './services/shared.service';
import appConfigLocation from './app.config.locations';
import appConfigAuth from './app.config.auth';
import appConfigTranslations from './app.config.translations';
import loadingInterceptor from './app.loadingInterceptor';
import loadingInterceptorConfig from './app.config.loadingInterceptor';
import appRunQueryStringInterceptor from './app.run.queryStringInterceptor';
import config from './config/config';
import angularMoment from 'angular-moment';
import cacheService from './services/cache.service';
import dropdownManager from './services/dropdown.service'
import cookiesConsent from './services/cookiesConsent.service';
import cookiesService from './services/cookies.service';

angular.module('app', [
    config,
    uiRouter,
    uiBootstrap,
    translate,
    translateStaticLoader,
    Common,
    Routes,
    ngResource,
    offClick,
    angularMessages,
    sharedService,
    angularMoment,
    cacheService,
    dropdownManager,
    cookiesConsent,
    cookiesService
])
    .config(appConfigLocation)
    .config(appConfigAuth)
    .config(appConfigTranslations)
    .run(appRunQueryStringInterceptor)
    .value('DATE_FORMAT', 'MM/DD/YYYY HH:mm [[]dddd D, MMMM  h:mmA[]]')
    .component('app', AppComponent)
    .config(loadingInterceptorConfig)
    .factory('loadingInterceptor', loadingInterceptor);





// WEBPACK FOOTER //
// ./client/app/app.js